import {DateRange} from '@domain/date-range';
import {moment} from '@vdw/angular-component-library';
import {filter, first, last} from 'lodash-es';

export function getItemsForDateRange<T extends {startDate: Date; endDate: Date}>(items: T[], dateRange: DateRange): T[] {
  const momentDateRange = moment.range(first(dateRange), last(dateRange));

  return filter(items, (item: T) => moment.range(item.startDate, item.endDate).overlaps(momentDateRange, {adjacent: true}));
}
